import { render, staticRenderFns } from "./UpdatePointProgram.vue?vue&type=template&id=57bf6e88"
import script from "./UpdatePointProgram.vue?vue&type=script&lang=js"
export * from "./UpdatePointProgram.vue?vue&type=script&lang=js"
import style0 from "./UpdatePointProgram.vue?vue&type=style&index=0&id=57bf6e88&prod&lang=css"
import style1 from "./UpdatePointProgram.vue?vue&type=style&index=1&id=57bf6e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports